export default {
  pagination: {
    perPage: 20
  },
  banner: {
    duration: 3000
  }
}
